// extracted by mini-css-extract-plugin
export var courseName = "SkillCourseBottomPurchaseCard-module--courseName--69fa1";
export var courseRating = "SkillCourseBottomPurchaseCard-module--courseRating--1e716";
export var courseStatus = "SkillCourseBottomPurchaseCard-module--courseStatus--01d86";
export var lmsScrollbar = "SkillCourseBottomPurchaseCard-module--lms-scrollbar--f3eb8";
export var purchaseButton = "SkillCourseBottomPurchaseCard-module--purchaseButton--baa22";
export var purchaseButtonText = "SkillCourseBottomPurchaseCard-module--purchaseButtonText--563d7";
export var purchaseContainer = "SkillCourseBottomPurchaseCard-module--purchaseContainer--43cb2";
export var purchaseContent = "SkillCourseBottomPurchaseCard-module--purchaseContent--500b3";